import React, { useEffect, useMemo } from "react";
import { Form, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchWhatsAppRegistrations } from "../features/whatsapp/whatsappSlice";

const WhatsAppSenderSelect = ({
  visible,
  name = "senderRegistrationId",
  label = "WhatsApp sender number",
  onChange,
}) => {
  const dispatch = useDispatch();
  const { registrations = [], loadingRegistrations = false } = useSelector(
    (state) => state.whatsapp || {}
  );

  useEffect(() => {
    if (visible) {
      dispatch(fetchWhatsAppRegistrations());
    }
  }, [dispatch, visible]);

  const options = useMemo(
    () =>
      (registrations || []).map((item) => ({
        value: item?.id,
        label: `${item?.displayName || "WhatsApp number"} · ${item?.phoneNumber || "-"}${
          item?.accountName ? ` · ${item.accountName}` : ""
        }`,
      })),
    [registrations]
  );

  if (!visible) {
    return null;
  }

  return (
    <Form.Item
      name={name}
      label={label}
      extra="Optional. Leave blank to use the default WhatsApp number."
    >
      <Select
        allowClear
        showSearch
        loading={loadingRegistrations}
        placeholder="Use default WhatsApp number"
        options={options}
        optionFilterProp="label"
        onChange={onChange}
        filterOption={(input, option) =>
          (option?.label?.toLocaleLowerCase() ?? "").includes(
            input?.toLocaleLowerCase()
          )
        }
      />
    </Form.Item>
  );
};

export default WhatsAppSenderSelect;
